import { Injectable } from '@angular/core';
import { ApiResponse, ModulePermissions } from '../../common/models/common.model';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpRoutingService } from '../../common/services/http-routing.service';
import { AuthService } from '../../auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ModuleSecurityService {
  /**
   * Service constructor to inject the other needed services here.
   * @param http Service to send the api request to the server.
   * @param authService To access the functions inside the AuthService.
   */
  constructor(
    private http: HttpRoutingService,
    private authService: AuthService
  ) { }
  /**
   * Method which is used to get all module access based on user role.
   */
  getUserRolePermissions(): Observable<ApiResponse<ModulePermissions>> {
    return this.http.getMethod('getUserRolePermissions').pipe(map((res: ApiResponse<ModulePermissions>) => {
      this.authService.user.next(res.data.user);
      return res;
    }), catchError(err => {
      return throwError(() => err);
    }));
  }
}
